export default "__VITE_ASSET__D$yZOHgU__"